import Cookies from "js-cookie";

const apiKey = process.env.REACT_APP_API_KEY;

export function crmHeaders(extra = {}) {
    const username = Cookies.get("username");
    const role = Cookies.get("user_role");
    return {
        Authorization: apiKey,
        "Content-Type": "application/json",
        ...(username ? { "X-CRM-Username": username } : {}),
        ...(role ? { "X-CRM-Role": role } : {}),
        ...extra,
    };
}

export function crmMultipartHeaders(extra = {}) {
    const username = Cookies.get("username");
    const role = Cookies.get("user_role");
    return {
        Authorization: apiKey,
        ...(username ? { "X-CRM-Username": username } : {}),
        ...(role ? { "X-CRM-Role": role } : {}),
        ...extra,
    };
}
